import { render, staticRenderFns } from "./EventConfig.vue?vue&type=template&id=5e18ef8e"
import script from "./EventConfig.vue?vue&type=script&lang=js"
export * from "./EventConfig.vue?vue&type=script&lang=js"
import style0 from "./EventConfig.vue?vue&type=style&index=0&id=5e18ef8e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports